











import { Vue, Component } from 'vue-property-decorator';
import { fetchNewslist } from '@/api/api';
import NewsList from '../components/NewsList.vue';
@Component({
  components: {
    NewsList,
  },
})
export default class Detail extends Vue {
  title: any = {};
  classId: any = null;
  async created() {
    const type = this.$route.query.type;
    switch (Number(type)) {
      case 1:
        this.title.image = require('../assets/1.png');
        this.title.name = '图文专版';
        this.classId = 4416;
        break;
      case 2:
        this.title.image = require('../assets/2.png');
        this.title.name = '30秒短视频';
        this.classId = 4417;
        break;
      case 3:
        this.title.image = require('../assets/3.png');
        this.title.name = '体验打卡';
        this.classId = 4418;
        break;
    }
  }
}
